module.exports = function() {
  return new Worker(__webpack_public_path__ + "c3bc8119d110c962745b.worker.js");
};